import { createUserManager } from "redux-oidc";

const userManagerConfig = {
  authority: `${process.env.REACT_APP_AUTH_AUTHORITY}`,
  client_id: `${process.env.REACT_APP_AUTH_CLIENT_ID}`,
  response_type: 'code',
  scope: `${process.env.REACT_APP_AUTH_CLIENT_SCOPE}`,
  redirect_uri: `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}/callback`,
  silent_redirect_uri: `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}/silent_renew.html`,
  post_logout_redirect_uri: `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}`,
  automaticSilentRenew: true,
  filterProtocolClaims: true,
  loadUserInfo: true
};

const userManager = createUserManager(userManagerConfig);

export function userIsInAnyRole(user, allowedRoles) {
  const assignedRole = user.profile.role;

  if(assignedRole instanceof Array) {
    return assignedRole.some(x => allowedRoles.some(y => x === y));
  } else if(typeof assignedRole === 'string') {
    return allowedRoles.some(x => x === assignedRole);
  } else {
    throw new Error('unhandled case of assigned role  ' + assignedRole);
  }
};

export default userManager;
